var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContenedor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.3,116.8c-2.6,0-4.7-2.1-4.7-4.7V38c0-2.6,2.1-4.7,4.7-4.7s4.7,2.1,4.7,4.7v74.1c0,2.6-2.1,4.7-4.7,4.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.8,103.2c-2.6,0-4.7-2.1-4.7-4.7v-46.9c0-2.6,2.1-4.7,4.7-4.7s4.7,2.1,4.7,4.7v46.9c0,2.6-2.1,4.7-4.7,4.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.8,100.1c-2.6,0-4.7-2.1-4.7-4.7v-40.6c0-2.6,2.1-4.7,4.7-4.7s4.7,2.1,4.7,4.7v40.6c0,2.6-2.1,4.7-4.7,4.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.8,96.9c-2.6,0-4.7-2.1-4.7-4.7v-34.4c0-2.6,2.1-4.7,4.7-4.7s4.7,2.1,4.7,4.7v34.4c0,2.6-2.1,4.7-4.7,4.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.7,95.4c-2.6,0-4.7-2.1-4.7-4.7v-29.7c0-2.6,2.1-4.7,4.7-4.7s4.7,2.1,4.7,4.7v29.7c0,2.6-2.1,4.7-4.7,4.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.7,37.6l-105.9-9.3c-.4,0-.8,0-1.2,0h-.2c0,0-.1,0-.2,0-.1,0-.3,0-.4,0h0L3.5,37.7c-2.1.6-3.5,2.4-3.5,4.5v65.6c0,2.1,1.4,4,3.5,4.5l34.4,9.4c.1,0,.2,0,.3,0h1.3l106.2-9.4c2.4-.2,4.3-2.2,4.3-4.7V42.2c0-2.4-1.8-4.5-4.3-4.7h0ZM9.4,45.8l25-6.8v72.1l-25-6.8v-58.5h0ZM140.6,103.6l-96.9,8.6V38l96.9,8.6v57h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContenedor);
export default __webpack_public_path__ + "static/media/contenedor.c1577bef51144d963756a17f77475790.svg";
export { ForwardRef as ReactComponent };